// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"371b882e","730":"524afa4b","953":"e466691b"}[chunkId] + ".chunk.css";
};